import {
  ADD_KEY_MAPPINGS_SUCCESS,
  BaseActionType,
  DELETE_KEY_MAPPINGS_SUCCESS,
  LOAD_KEY_MAPPINGS_SUCCESS,
  LOAD_MORE_KEY_MAPPINGS_SUCCESS,
  UPDATE_GET_KEY_MAPPINGS_REQUEST,
  UPDATE_KEY_MAPPINGS_PAGE_NUM,
  UPDATE_KEY_MAPPINGS_SUCCESS,
  UPLOAD_KEY_MAPPINGS_SUCCESS,
} from '../actions/actionTypes'

import { DeviceKeyMappingInfo, DeviceKeyMappingsState } from './initialState'

const initialStateKeyMappings: DeviceKeyMappingsState = {
  deviceKeyMappings: [],
  continuationToken: '',
}
const initialStateGetKeyMappingsRequest: DeviceKeyMappingInfo = {
  deviceId: '',
  userEmailAddress: '',
  adGroupName: '',
  continuationToken: '',
}

const initialStateKeyMappingsPageNum = 1

export function keyMappingsReducer(
  state = initialStateKeyMappings,
  action: BaseActionType,
): DeviceKeyMappingsState {
  switch (action.type) {
    case ADD_KEY_MAPPINGS_SUCCESS: {
      return {
        ...state,
        deviceKeyMappings: [
          action.payload as DeviceKeyMappingInfo,
          ...state.deviceKeyMappings,
        ],
      }
    }
    case UPDATE_KEY_MAPPINGS_SUCCESS: {
      const deviceKeyMappings = state.deviceKeyMappings.map(
        (keyMapping: DeviceKeyMappingInfo) =>
          keyMapping.deviceId !==
          (action.payload as DeviceKeyMappingInfo).deviceId
            ? keyMapping
            : (action.payload as DeviceKeyMappingInfo),
      )
      return { ...state, deviceKeyMappings }
    }
    case UPLOAD_KEY_MAPPINGS_SUCCESS: {
      const newKeyMappings = (action.payload as DeviceKeyMappingInfo[])
        .filter((nonNullKeyMapping) => nonNullKeyMapping)
        .map((keyMapping) => keyMapping)
      let updatedKeyMappings: DeviceKeyMappingInfo[] = []
      if (state.deviceKeyMappings.length !== 0) {
        updatedKeyMappings = state.deviceKeyMappings.map(
          (keyMapping: DeviceKeyMappingInfo) => {
            for (let i = 0; i < newKeyMappings.length; i++) {
              if (keyMapping.deviceId === newKeyMappings[i].deviceId) {
                return newKeyMappings
                  .splice(i, 1)
                  .shift() as DeviceKeyMappingInfo
              }
            }
            return keyMapping
          },
        )
      }
      return {
        ...state,
        deviceKeyMappings: [...newKeyMappings, ...updatedKeyMappings],
      }
    }
    case LOAD_KEY_MAPPINGS_SUCCESS:
      return action.payload as DeviceKeyMappingsState
    case LOAD_MORE_KEY_MAPPINGS_SUCCESS:
      return {
        continuationToken: (action.payload as DeviceKeyMappingsState)
          .continuationToken,
        deviceKeyMappings: [
          ...state.deviceKeyMappings,
          ...(action.payload as DeviceKeyMappingsState).deviceKeyMappings,
        ],
      }
    case DELETE_KEY_MAPPINGS_SUCCESS: {
      const deviceKeyMappings = state.deviceKeyMappings.filter(
        (keyMappings: DeviceKeyMappingInfo) =>
          keyMappings.deviceId !==
          (action.payload as DeviceKeyMappingInfo).deviceId,
      )
      return { ...state, deviceKeyMappings }
    }
    default:
      return state
  }
}

export function getKeyMappingsRequestReducer(
  state = initialStateGetKeyMappingsRequest,
  action: BaseActionType,
): DeviceKeyMappingInfo {
  switch (action.type) {
    case UPDATE_GET_KEY_MAPPINGS_REQUEST:
      return action.payload as DeviceKeyMappingInfo
    default:
      return state
  }
}

export function keyMappingsPageNumReducer(
  state = initialStateKeyMappingsPageNum,
  action: BaseActionType,
): number {
  switch (action.type) {
    case UPDATE_KEY_MAPPINGS_PAGE_NUM:
      return action.payload as number
    default:
      return state
  }
}
